// arise-frontend/src/components/auth/RouteGuards.jsx
import { Fragment } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { safeRedirect } from '../../utils/safeRedirect';

function StatusCard({ children }) {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 'calc(64px + 1.5rem) 1rem 2rem',
    }}>
      <div className="glass" style={{
        padding: '1.75rem 2rem', textAlign: 'center', maxWidth: 420,
        fontFamily: 'Space Mono, monospace', fontSize: 11, color: '#a0c4d8',
      }}>
        {children}
      </div>
    </div>
  );
}

/** Signed-out visitors are sent to /login and returned to the page they wanted. */
export function ProtectedRoute({ children }) {
  const { status, user, refresh } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <StatusCard><div role="status">Verifying session…</div></StatusCard>;
  }
  if (status === 'unavailable') {
    return (
      <StatusCard>
        <div role="alert" style={{ marginBottom: '1rem' }}>
          Could not verify your session. The server may be unreachable.
        </div>
        <button type="button" className="btn-primary" onClick={refresh}>Retry</button>
      </StatusCard>
    );
  }
  if (status !== 'authenticated' || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  // Keyed by user id: a different user always gets a fresh page (no leaked analysis state).
  return <Fragment key={user.id}>{children}</Fragment>;
}

/** Login/Register are for signed-out visitors; signed-in users are sent onward. */
export function GuestRoute({ children }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <StatusCard><div role="status">Verifying session…</div></StatusCard>;
  }
  if (status === 'authenticated') {
    return <Navigate to={safeRedirect(location.state && location.state.from)} replace />;
  }
  return children;
}
